import React, { useState, useEffect } from "react";
import eventBus from "src/utils/eventBus";
import { sendContact } from "src/api/MainApi";

const InquiryModal: React.FC = () => {
    const [username, setUserName] = useState("");
    const [phone, setPhone] = useState("");
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [errorUsername, setErrorUsername] = useState(false);
    const [errorPhone, setErrorPhone] = useState(false);
    const [errorPhoneLength, setErrorPhoneLength] = useState(false);
    const [errorTitle, setErrorTitle] = useState(false);
    const [errorContent, setErrorContent] = useState(false);        
    const [isHandlingBack, setIsHandlingBack] = useState(false);
    const [type, setType] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
  
    const onSubmit = (data: { username: string; phone: string; title: string; content: string }) => {
        const fetchData = async () => {
            const response = await sendContact(data);
            if (response) {
                eventBus.emit("completeModal:show", { type: "success" });
            } else {
                alert("문의사항 전송 실패!");
        }
        };
        fetchData();
    };
    const handleSubmit = () => {
        let hasError = false;
    
        if (!username.trim()) {
            setErrorUsername(true);
            hasError = true;
        } else {
            setErrorUsername(false);
        }
    
        if (!phone.trim()) {
            setErrorPhone(true);
            hasError = true;
        } else {
            setErrorPhone(false);
        }

        if (phone.trim().length > 11) {
            setErrorPhoneLength(true);
            hasError = true;
        } else {
            setErrorPhoneLength(false);
        }
    
        if (!title.trim()) {
            setErrorTitle(true);
            hasError = true;
        } else {
            setErrorTitle(false);
        }
    
        if (!content.trim()) {
            setErrorContent(true);
            hasError = true;
        } else {
            setErrorContent(false);
        }
    
        if (hasError) return;
    
        onSubmit({ username, phone, title, content });
        closeModal();
    };

    useEffect(() => {
        const onShowinquiry = (data: { type: "success" }) => {
            setType(data.type);
            setTimeout(() => setIsVisible(true), 10);
            if (window.history.state !== "modal-open") {
                window.history.pushState("modal-open", "", window.location.pathname);
            }
    };

    eventBus.on("inquiryModal:show", onShowinquiry);

    return () => {
        eventBus.off("inquiryModal:show", onShowinquiry);
    };
    }, []);

    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = "hidden";

            const handleBackButton = () => {
                if (!isVisible || isHandlingBack) return;

                setIsHandlingBack(true);
                closeModal();

                setTimeout(() => setIsHandlingBack(false), 200);
            };

            window.addEventListener("popstate", handleBackButton);

            return () => {
                document.body.style.overflow = "auto";
                window.removeEventListener("popstate", handleBackButton);
                setIsHandlingBack(false);
            };
        }
    }, [isVisible, isHandlingBack]);

    const closeModal = () => {
        setIsVisible(false); 
        setTimeout(() => setType(null), 300);
        setUserName("");
        setPhone("");
        setTitle("");
        setContent("");
    };

    if (!type) return null;

    return (
        <>
            <div className={`overlay ${isVisible ? "active" : ""}`} onClick={closeModal}></div>
            <div className={`modal fade ${isVisible ? "show" : ""} d-block`} tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content p-3" style={{ borderRadius: "8px" }}>
                        <div className="modal-header border-0">
                            <h3 className="modal-title fw-bold" id="inquiryModalLabel">문의하기</h3>
                            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <small className="fw-semibold mb-2 text-black4 d-inline-block">성함</small>
                            <input type="text" className={`form-control ${errorUsername ? "is-invalid" : ""}`} placeholder="성함을 입력해주세요." value={username} onChange={(e) => setUserName(e.target.value)} />
                            {errorUsername && <div className="invalid-feedback">성함을 입력해주세요.</div>}

                            <small className="fw-semibold mb-2 mt-3 text-black4 d-inline-block">연락처</small>
                            <input type="text" className={`form-control ${errorPhone || errorPhoneLength ? "is-invalid" : ""}`} placeholder="ex)01012345678" value={phone} onChange={(e) => setPhone(e.target.value)} />
                            {errorPhone && <div className="invalid-feedback">연락처를 입력해주세요.</div>}
                            {errorPhoneLength && <div className="invalid-feedback">최대 11자리까지 입력 가능합니다.</div>}

                            <small className="fw-semibold mb-2 mt-3 text-black4 d-inline-block">제목</small>
                            <input type="text" className={`form-control ${errorTitle ? "is-invalid" : ""}`} placeholder="제목을 입력해주세요." value={title} onChange={(e) => setTitle(e.target.value)} />
                            {errorTitle && <div className="invalid-feedback">제목을 입력해주세요.</div>}

                            <small className="fw-semibold mb-2 mt-3 text-black4 d-inline-block">내용</small>
                            <textarea className={`form-control ${errorContent ? "is-invalid" : ""}`} rows={4} placeholder="내용을 입력해주세요." value={content} onChange={(e) => setContent(e.target.value)} ></textarea>
                            {errorContent && <div className="invalid-feedback">내용을 입력해주세요.</div>}

                            <small className="small text-muted">
                                * 텔레모아는 사용자의 의견을 적극 반영하고 있습니다.<br />
                                * 단순 건의사항은 개인정보를 남겨주지 않으셔도 됩니다.<br />
                                * 입점 및 제휴 문의는 확인 후 가능한 빨리 회신드리겠습니다.
                            </small>
                        </div>
                        <div className="modal-footer border-0">
                            <button type="button" className="btn btn-dark w-100 pt-3 pb-3" onClick={handleSubmit}>등록</button>
                        </div>              
                    </div>
                </div>
            </div>
        </>
    );
};

export default InquiryModal;
